<template>
  <div
    class="ui dimmer modals page transition visible active"
    style="display: flex !important"
  >
    <div
      class="ui small test modal transition visible active"
      style="display: block !important;"
    >
      <div class="ui icon header">
        <i
          class="envelope icon"
          aria-hidden="true"
        />
        Notification d'abonnement
      </div>
      <div class="content">
        <p
          v-if="project.notified_members_at"
          class="ui info message"
        >
          <i
            class="info circle icon"
            aria-hidden="true"
          />
          Une notification a déjà été envoyée
          le {{ project.notified_members_at }} par {{ project.notified_members_by }} 
        </p>
        <p>Cette action enverra une notification à tous les membres. Confirmez-vous l’envoi&nbsp;?</p>
        <div class="ui hidden divider" />
        <div class="ui warning message">
          <i
            class="exclamation triangle icon"
            aria-hidden="true"
          />
          Assurez-vous d’avoir enregistré vos modifications avant de notifier les membres du projet.
        </div>
      </div>
      <div class="actions">
        <div
          class="ui negative button"
          @click="$emit('closeNotifyModal')"
        >
          Annuler
        </div>
        <div
          class="ui positive right labeled icon button"
          @click="onNotifyMembers"
        >
          Confirmer
          <i class="checkmark icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import projectAPI from '@/services/project-api';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'NotifyMemberModal',

  computed: {
    ...mapState('projects', ['project']),
  },

  methods: {
    ...mapMutations([
      'DISPLAY_MESSAGE',
      'DISPLAY_LOADER',
      'DISCARD_LOADER'
    ]),

    async onNotifyMembers() {
      this.DISPLAY_LOADER('Notification des membres du projet en cours ...');
      try {
        const baseUrl = this.$store.state.configuration.VUE_APP_DJANGO_API_BASE;
        await projectAPI.notifyProjectCreation(baseUrl, this.project.slug);
        // Émet l'événement pour lancer le polling dans le parent
        this.$emit('notificationStarted');
        this.DISPLAY_MESSAGE({
          comment: 'La notification est en cours d’envoi.',
          level: 'info'
        });
        // Recharger le projet pour mettre à jour les champs notified_members_* à afficher
        this.$store.dispatch('projects/GET_PROJECT', this.$route.params.slug);
      } catch (err) {
        this.stopNotificationProcess();
        if (err.response?.status === 403) {
          this.DISPLAY_MESSAGE({
            comment: 'Vous n’avez pas les droits pour cette action.',
            level: 'negative'
          });
        } else {
          this.DISPLAY_MESSAGE({
            comment: 'Une erreur est survenue lors de l’envoi de la notification.',
            level: 'negative'
          });
        }
      } finally {
        this.DISCARD_LOADER();
        this.$emit('closeNotifyModal');
      }
    }
  }
};
</script>
